import React from 'react';
import Icon from '.';

const CloseIcon = props => (
	<Icon {...props} viewBox="0 0 24 24">
		<title>Close</title>
		<polygon
			fill="currentColor"
			points="20.0830078,5.3310547 18.6689453,3.9169922 12,10.5859375 5.3310547,3.9169922 3.9169922,5.3310547 10.5859375,12
				3.9169922,18.6689453 5.3310547,20.0830078 12,13.4140625 18.6689453,20.0830078 20.0830078,18.6689453 13.4140625,12 "
		/>
	</Icon>
);

export default CloseIcon;
